<template>
  <div class="axes_text">
    <violet-bar>Texte introduisant les axes</violet-bar>
    <div class="box">
      <label for="" class="label">Zone de texte</label>
      <textarea
        name=""
        id=""
        cols="30"
        rows="10"
        class="textarea is-small "
        v-model="form.text"
      ></textarea>
    </div>
    <div class="buttons">
      <button class="button is-primary" @click="save">
        Enregistrer
      </button>
    </div>
  </div>
</template>
<script>
import VioletBar from "../Projects/VioletBar";
import { types } from "../../store/actions/misc";

export default {
  name: "axes_text",
  data() {
    return {
      form: {
        text: ""
      }
    };
  },
  components: { VioletBar },
  mounted() {
    this.fetch();
  },
  methods: {
    async save() {
      this.form = await this.$store.dispatch(types.SET_AXE_TEXTS, this.form);
    },
    async fetch() {
      try {
        this.form = await this.$store.dispatch(types.GET_AXE_TEXTS);
      } catch (e) {
        this.form = { text: "" };
      }
    }
  }
};
</script>
